import { useConsumerBranding } from '@/consumer/hooks/use-consumer-branding'

/**
 * Whether customers may raise new claims for this tenant (staff flag + the
 * tenant admin's setting, resolved server-side). Only an explicit `false`
 * counts as off, so entry points never disappear while branding is loading.
 */
export function useConsumerClaimsEnabled(overrideSlug?: string): boolean {
  const { data } = useConsumerBranding(overrideSlug)
  return data?.feature_flags?.consumer_claims !== false
}
